export enum ToolbarQuery {
  ConferenceState = 'coop',
  Debug = 'debug',
  Snapshot = 's',

  ClipPlane = 'c',
  ShowModel = 'm',

  VisualMode = 'v',
  VisualModeBoth = 'vb',

  Palette = 'p',
  PaletteZeroPoint = 'pz',
  PaletteLowerBound = 'pl',
  PaletteUpperBound = 'pu',

  RemarksType = 'r',
  ControlsMode = 'cm',

  HistogramView = 'hv',
  // TODO temporary disabled since it doesnt work in viewer
  // HistogramLowerValue = 'hl',
  // HistogramUpperValue = 'hu',

  SwitchModels = 'sm',
  SwitchModelsRecognition = 'smr',
}
